// import { list } from './emojiList';
import emojiList from './emojiList.json';
// import { sequenceEmoji } from '../constants';

export const getEmojiList = () => emojiList;

/**
 * @name getEmojiListCreator
 * @function
 * @description Форматирование списка emoji к формату
 * @return [
 *  {
 *    position: 1,
 *    value: '👍',
 *    title: 'Like',
 *    search: ['like']
 *  }
 * ]
 */
// export const getEmojiListCreator = () => {
//   if (list) {
//     return list.map((item) => {
//       const position = sequenceEmoji.findIndex((emoji) => emoji === item.emoji);
//       return {
//         position: position === -1 ? 10000 : position,
//         value: item.emoji,
//         title: item.description,
//         search: [...item.tags, ...item.aliases],
//       }
//     }).sort((a, b) => a.position - b.position)
//   }
//   return [];
// };
